<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

		<fieldset class="form__group">
			<legend>Create the Lead User</legend>

			<div class="form__group">
				<input id="first-name" class="form__control" v-model="formData.firstName" v-validate required
				       placeholder="Enter the user's first name..." />
				<label for="first-name" class="form__label">First name</label>
				<div class="form__validation">{{ errors.first('firstName') }}</div>
			</div>

			<div class="form__group">
				<input id="surname" class="form__control" v-model="formData.surname" v-validate required
				       placeholder="Enter the user's surname..." />
				<label for="surname" class="form__label">Surname</label>
				<div class="form__validation">{{ errors.first('surname') }}</div>
			</div>

			<div class="form__group">
				<input id="position" class="form__control" v-model="formData.position" v-validate required
				       placeholder="Enter the user's job title..." />
				<label for="position" class="form__label">Position</label>
				<div class="form__validation">{{ errors.first('position') }}</div>
			</div>

			<FormControlSector label="Sector specialisations" v-model="formData.specialisms" name="specialisms"
			                   :multiple="true" v-validate="'required'">
			</FormControlSector>

			<FileUpload id="avatar" label="Profile picture" name="avatar" v-model="formData.avatar" v-validate="'required'">
			</FileUpload>

			<div class="form__group">
				<input id="email" class="form__control" v-model="formData.email" v-validate required
				       placeholder="Enter the user's email address..." />
				<label for="email" class="form__label">Email address</label>
				<div class="form__validation">{{ errors.first('email') }}</div>
			</div>

			<FormControlOffice label="Office location" placeholder="Select one of the company's offices"
			                   :member="this.id" v-model="formData.office" name="office" v-validate="'required'">
			</FormControlOffice>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='["submit", "avatar uploading"]'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='["submit", "avatar uploading"]'>Create User</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import MemberFormStep from './MemberFormStep';
	import FormControlSector from '../../Form/Control/FormControlSector';
	import FileUpload from '../../Form/FileUpload';
	import ValidationAlert from '../../ValidationAlert';
	import FormControlOffice from '../../Form/Control/FormControlOffice';

	export default {
		name: 'MemberFormStep2',
		components: {
			FormControlOffice,
			ValidationAlert,
			FileUpload,
			FormControlSector},
		mixins: [MemberFormStep],
		data() {
			return {
				formData: {
					firstName: null,
					surname: null,
					position: null,
					specialisms: [],
					avatar: null,
					email: null,
					office: null,
				}
			}
		},
	}
</script>
